export default __webpack_public_path__ + "12711a613094c520ee02da6914bd2984.svg";